import { Plugins } from '@leverege/plugin';
export const ExportFieldRendererFactory = Plugins.createFactory('ExportFieldRenderer', {
  pluginKey: 'renderer',
  strategy: Plugins.ALL
});
export const ExportModelCreatorFactory = Plugins.createFactory('ExportModelCreator', {
  pluginKey: 'creator',
  strategy: Plugins.ALL
});